import { createFCWidgetForForgotPasswordForm } from 'views/assets/scripts/friendlyCaptcha'
import runScripts from 'views/assets/scripts/runScripts'
import mountForgotPasswordFormContainer from 'views/containers/browser/ForgotPasswordContainer/mountForgotPasswordFormContainer'

runScripts(
  mountForgotPasswordFormContainer,
  createFCWidgetForForgotPasswordForm
)
